import { Component, Injector, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseEntityComponent, BaseEntityConfig, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CanComponentDeactivate } from 'src/app//core/can-deactivate-guard.service';
import { ROLE_AGENTE_ENVIO } from 'src/app/constantes/permissao.constants';
import { Amortizacao, NovasLiberacoesParaOperacao } from 'src/app/model/operacao-credito-livre.model';
import { LiberacaoOperacaoGarantida } from 'src/app/model/operacao-garantida.model';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { LiberacaoCreditoLivreService } from './liberacao-credito-livre.service';




@Component({
    selector: 'app-liberacao-detalhe',
    templateUrl: './liberacao-detalhe.component.html',
    styleUrls: ['./liberacao-detalhe.component.scss'],
    standalone: false
})
export class LiberacaoDetalheComponent
  extends BaseEntityComponent<NovasLiberacoesParaOperacao> implements OnInit, CanComponentDeactivate {

  private ocorrencias: OcorrenciaValidacaoVO[] = [];
  private idOperacaoAgente: string;
  private carregada = false;
  private estadoInicial: NovasLiberacoesParaOperacao;

  @ViewChild(BnConfirmDirective, {static: false}) vc: BnConfirmDirective;
  @ViewChild('meuId', {static: false}) botoesPersonalizados: TemplateRef<any>;
  @ViewChild('formLiberacao', {static: false}) formLiberacao: NgForm;

  // @override
  constructor (
    protected injector: Injector,
    protected liberacaoCreditoLivreService: LiberacaoCreditoLivreService,
    private modalService: BnModalMessageService,
    private usuarioService: BnUsuarioService,
    private permissaoService: PermissaoService,
    private _modalService: NgbModal,
    private alertsService: BnAlertsService,
    private loadingService: BnLoadingService,
    private removerAlertasService: RemoverAlertasService,
    public router: Router) {
    
    super(liberacaoCreditoLivreService);
    this.estadoInicial = <NovasLiberacoesParaOperacao>this.router.getCurrentNavigation().extras.state;
  }

  // @override
  ngOnInit() {
	this.permissaoService
		.getPermissoesUsuarioAutenticado()
		.subscribe ((resp: any) => {
			//console.debug(this.estadoInicial);
			this.estadoInicial.amortizacoes.forEach(a => a.valor = this.ajustaCasasDecimais(a.valor));
			this.model = this.estadoInicial;
			console.log(`liberações atuais da operação ${this.model.id} recuperadas`);
			
			// rota para voltar à tela de garantia 
			this.setConfig(new BaseEntityConfig(`operacoes/${this.model.id}`));
			this.carregada = true
    	});
  }
  
  adicionarLiberacao() {
    let aux = this.getModelAs();
    aux.liberacoes.push(new LiberacaoOperacaoGarantida());
  }

  removerLiberacao(i) {
    let aux = this.getModelAs();
    aux.liberacoes.splice(i, 1);
  }

  adicionarAmortizacao() {
    let aux = this.getModelAs();
    aux.amortizacoes.push(new Amortizacao());
  }

  removerAmortizacao(i) {
    let aux = this.getModelAs();
    aux.amortizacoes.splice(i, 1);
  }

  verificaLiberacoesOrdenadas(liberacoes: LiberacaoOperacaoGarantida[]) {
    let liberacaoAnterior = undefined;
    for (let liberacao of liberacoes) {
      if (liberacaoAnterior != undefined && liberacaoAnterior.data > liberacao.data) {
        return false;
      }
      liberacaoAnterior = liberacao;
    }
    return true;
  }

  salvar() {
    super.antesDeSalvar();
    this.ocorrencias = [];
    this.removerAlertasService.removerTodos();
    let clone: NovasLiberacoesParaOperacao = <NovasLiberacoesParaOperacao>{...this.model};
    clone.liberacoes = clone.liberacoes.filter(lib => !lib.id);
    this.liberacaoCreditoLivreService['enviarLiberacoes'](clone, false).subscribe(resp => {
      this.voltarParaLista()
      this.aposSalvar();
    }, error => {
      console.log(error);
      this.ocorrencias = this.liberacaoCreditoLivreService.ocorrencias;
    });
    
  }

  private ajustaCasasDecimais(valor: number): number {
    if (valor == undefined) {
      return undefined;
    }
    return Number((Math.round(valor * 100) / 100).toFixed(2));
  }


  // @overide
  aposSalvar() {
    this.exibeMensagemSucesso();
  }

  verificaSePodeSair(): Observable<string> {
    this.vc.abrirModal();
    return this.vc.resultadoConfirm.asObservable();
  }

  private ajustaCasasDecimaisAmortizacoes() {
    let aux = this.getModelAs();
    if (aux.amortizacoes && aux.amortizacoes.length) {
      for (let amortizacao of aux.amortizacoes) {
        amortizacao.valor = Math.round(amortizacao.valor * 100) / 100;
      }
    }
  }

  exibeMensagemSucesso(): void {
    this.messageService.addMessage({
      title: 'Sucesso',
      type: 'CRUD_OPERATION',
      level: messageLevel.SUCCESS,
      message: 'Liberações incluídas com sucesso.'
    });
  }

  canDeactivate(): Observable<boolean> | boolean {
    if ( this.formLiberacao.pristine) {
      return true;
    } else {
      // map necessario porque bnConfirm retorna string e nao boolean
      return this.verificaSePodeSair().pipe(map(res => res === 'ok'));
    }
  }

  abrirModal(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
    if (hasBotoes === true) {
      this.modalService.abrir('Confirmação', msg, tamanho, undefined, this.botoesPersonalizados);
    }
  }

  private getModelAs(): NovasLiberacoesParaOperacao {
    let retorno: any = this.model;
    return retorno;
  }

  close() {
    this.modalService.close();
  }

  dismiss() {
    this.modalService.dismiss();
  }

}
